<template>
    <span
        class="relative inline-flex items-center py-5px px-2.5 group mr-5px mb-5px bg-next-gray-md-darker hover:bg-white hover:shadow">
        <slot></slot>
        <i tabindex="1" @click.stop.prevent="$emit('remove', $event)" v-if="!$attrs.readonly"
           class="hidden cursor-pointer fa fa-times group-hover:block text-next-orange p-0 ml-2">
        </i>
    </span>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'MultiselectOption',
    components: {},
})
export default class MultiselectOption extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
